import LearningSpaceBugReports from './LearningSpaceBugReports'

export default LearningSpaceBugReports
